/**
 * CM > IPS > 침입탐지 프로파일 > 서비스 공격 방어
 *
 * @since 2021-09-09
 * @author wj_tams_dev04
 */
import {i18n} from '~/plugins/i18n'
import {SystemApiPrefix as smApiPrefix, CmApiPrefix as cmApiPrefix} from '~/utils/restApi'

/**
 * 자료 구조 변경
 * ex)
 *  - ngips_prf_id => prf_id
 *  - ads_ips_prf_id => prf_id
**/
class ServiceAttackDefense {
  constructor (obj, modelType = 'ips') {
    this.keyList = []
    this.orgKeyList = []
    if (_.has(obj, 'ngips_prf_id')) this.modelType = 'ips'
    else if (_.has(obj, 'ads_ips_prf_id')) this.modelType = 'ads'
    else this.modelType = modelType

    this.prf_id = this.getValue(obj, ['ngips_prf_id', 'ads_ips_prf_id'], 'prf_id')
    this.ddos_id = this.getValue(obj, ['ngips_ddos_id', 'ads_ddos_id'], 'ddos_id')
    this.ddos_opt_use_yn = this.getValue(obj, ['ngips_ddos_opt_use_yn', 'ads_ddos_opt_use_yn'], 'ddos_opt_use_yn')
    this.ddos_cate = this.getValue(obj, ['ngips_ddos_cate', 'ads_ddos_cate'], 'ddos_cate')
    this.ddos_name = this.getValue(obj, ['ngips_ddos_name', 'ads_ddos_name'], 'ddos_name')
    this.ddos_opt_action_yn = this.getValue(obj, ['ngips_ddos_opt_action_yn', 'ads_ddos_opt_action_yn'], 'ddos_opt_action_yn')
    this.ddos_opt_block_key = this.getValue(obj, ['ngips_ddos_opt_block_key', 'ads_ddos_opt_block_key'], 'ddos_opt_block_key')
    this.ddos_opt_excpthost = this.getValue(obj, ['ngips_ddos_opt_excpthost', 'ads_ddos_opt_excpthost'], 'ddos_opt_excpthost')
    this.ddos_opt_direction = this.getValue(obj, ['ngips_ddos_opt_direction', 'ads_ddos_opt_direction'], 'ddos_opt_direction')
    this.ddos_opt_detect_limit = this.getValue(obj, ['ngips_ddos_opt_detect_limit', 'ads_ddos_opt_detect_limit'], 'ddos_opt_detect_limit')
    this.ddos_std_plcy_unit_dtc_limit = this.getValue(obj, ['ngips_ddos_std_plcy_unit_dtc_limit', 'ads_ddos_std_plcy_unit_dtc_limit'], 'ddos_std_plcy_unit_dtc_limit')
    this.ddos_opt_block_limit = this.getValue(obj, ['ngips_ddos_opt_block_limit', 'ads_ddos_opt_block_limit'], 'ddos_opt_block_limit')
    this.ddos_std_plcy_unit_blk_limit = this.getValue(obj, ['ngips_ddos_std_plcy_unit_blk_limit', 'ads_ddos_std_plcy_unit_blk_limit'], 'ddos_std_plcy_unit_blk_limit')
    this.ddos_opt_base_time = this.getValue(obj, ['ngips_ddos_opt_base_time', 'ads_ddos_opt_base_time'], 'ddos_opt_base_time')
    this.ddos_std_plcy_unit_bs_tm = this.getValue(obj, ['ngips_ddos_std_plcy_unit_bs_tm', 'ads_ddos_std_plcy_unit_bs_tm'], 'ddos_std_plcy_unit_bs_tm')
    this.ddos_opt_block_time = this.getValue(obj, ['ngips_ddos_opt_block_time', 'ads_ddos_opt_block_time'], 'ddos_opt_block_time')
    this.ddos_std_plcy_unit_blk_tm = this.getValue(obj, ['ngips_ddos_std_plcy_unit_blk_tm', 'ads_ddos_std_plcy_unit_blk_tm'], 'ddos_std_plcy_unit_blk_tm')
    this.ddos_opt_param1 = this.getValue(obj, ['ngips_ddos_opt_param1', 'ads_ddos_opt_param1'], 'ddos_opt_param1')
    this.ddos_std_plcy_unit_param1 = this.getValue(obj, ['ngips_ddos_std_plcy_unit_param1', 'ads_ddos_std_plcy_unit_param1'], 'ddos_std_plcy_unit_param1')
    this.ddos_opt_param2 = this.getValue(obj, ['ngips_ddos_opt_param2', 'ads_ddos_opt_param2'], 'ddos_opt_param2')
    this.ddos_std_plcy_unit_param2 = this.getValue(obj, ['ngips_ddos_std_plcy_unit_param2', 'ads_ddos_std_plcy_unit_param2'], 'ddos_std_plcy_unit_param2')
    this.ddos_opt_attacker_mask_v4 = this.getValue(obj, ['ngips_ddos_opt_attacker_mask_v4', 'ads_ddos_opt_attacker_mask_v4'], 'ddos_opt_attacker_mask_v4')
    this.ddos_opt_victim_mask_v4 = this.getValue(obj, ['ngips_ddos_opt_victim_mask_v4', 'ads_ddos_opt_victim_mask_v4'], 'ddos_opt_victim_mask_v4')
    this.ddos_opt_attacker_mask_v6 = this.getValue(obj, ['ngips_ddos_opt_attacker_mask_v6', 'ads_ddos_opt_attacker_mask_v6'], 'ddos_opt_attacker_mask_v6')
    this.ddos_opt_victim_mask_v6 = this.getValue(obj, ['ngips_ddos_opt_victim_mask_v6', 'ads_ddos_opt_victim_mask_v6'], 'ddos_opt_victim_mask_v6')
    this.ddos_risk = this.getValue(obj, ['ngips_ddos_risk', 'ads_ddos_risk'], 'ddos_risk')
    this.ddos_effect = this.getValue(obj, ['ngips_ddos_effect', 'ads_ddos_effect'], 'ddos_effect')
    this.ddos_opt_log_yn = this.getValue(obj, ['ngips_ddos_opt_log_yn', 'ads_ddos_opt_log_yn'], 'ddos_opt_log_yn')
    this.ddos_opt_dump_yn = this.getValue(obj, ['ngips_ddos_opt_dump_yn', 'ads_ddos_opt_dump_yn'], 'ddos_opt_dump_yn')
    this.ddos_opt_mail_yn = this.getValue(obj, ['ngips_ddos_opt_mail_yn', 'ads_ddos_opt_mail_yn'], 'ddos_opt_mail_yn')
    this.ddos_opt_alert_yn = this.getValue(obj, ['ngips_ddos_opt_alert_yn', 'ads_ddos_opt_alert_yn'], 'ddos_opt_alert_yn')
    this.ddos_opt_alarm_yn = this.getValue(obj, ['ngips_ddos_opt_alarm_yn', 'ads_ddos_opt_alarm_yn'], 'ddos_opt_alarm_yn')
    this.ddos_opt_cfg_status = this.getValue(obj, ['ngips_ddos_opt_cfg_status', 'ads_ddos_opt_cfg_status'], 'ddos_opt_cfg_status')
    this.ddos_std_plcy_def_dtc_limit = this.getValue(obj, ['ngips_ddos_std_plcy_def_dtc_limit', 'ads_ddos_std_plcy_def_dtc_limit'], 'ddos_std_plcy_def_dtc_limit')
    this.ddos_std_plcy_min_dtc_limit = this.getValue(obj, ['ngips_ddos_std_plcy_min_dtc_limit', 'ads_ddos_std_plcy_min_dtc_limit'], 'ddos_std_plcy_min_dtc_limit')
    this.ddos_std_plcy_max_dtc_limit = this.getValue(obj, ['ngips_ddos_std_plcy_max_dtc_limit', 'ads_ddos_std_plcy_max_dtc_limit'], 'ddos_std_plcy_max_dtc_limit')
    this.ddos_std_plcy_def_blk_limit = this.getValue(obj, ['ngips_ddos_std_plcy_def_blk_limit', 'ads_ddos_std_plcy_def_blk_limit'], 'ddos_std_plcy_def_blk_limit')
    this.ddos_std_plcy_min_blk_limit = this.getValue(obj, ['ngips_ddos_std_plcy_min_blk_limit', 'ads_ddos_std_plcy_min_blk_limit'], 'ddos_std_plcy_min_blk_limit')
    this.ddos_std_plcy_max_blk_limit = this.getValue(obj, ['ngips_ddos_std_plcy_max_blk_limit', 'ads_ddos_std_plcy_max_blk_limit'], 'ddos_std_plcy_max_blk_limit')
    this.ddos_std_plcy_def_bs_tm = this.getValue(obj, ['ngips_ddos_std_plcy_def_bs_tm', 'ads_ddos_std_plcy_def_bs_tm'], 'ddos_std_plcy_def_bs_tm')
    this.ddos_std_plcy_min_bs_tm = this.getValue(obj, ['ngips_ddos_std_plcy_min_bs_tm', 'ads_ddos_std_plcy_min_bs_tm'], 'ddos_std_plcy_min_bs_tm')
    this.ddos_std_plcy_max_bs_tm = this.getValue(obj, ['ngips_ddos_std_plcy_max_bs_tm', 'ads_ddos_std_plcy_max_bs_tm'], 'ddos_std_plcy_max_bs_tm')
    this.ddos_std_plcy_def_blk_tm = this.getValue(obj, ['ngips_ddos_std_plcy_def_blk_tm', 'ads_ddos_std_plcy_def_blk_tm'], 'ddos_std_plcy_def_blk_tm')
    this.ddos_std_plcy_min_blk_tm = this.getValue(obj, ['ngips_ddos_std_plcy_min_blk_tm', 'ads_ddos_std_plcy_min_blk_tm'], 'ddos_std_plcy_min_blk_tm')
    this.ddos_std_plcy_max_blk_tm = this.getValue(obj, ['ngips_ddos_std_plcy_max_blk_tm', 'ads_ddos_std_plcy_max_blk_tm'], 'ddos_std_plcy_max_blk_tm')
    this.ddos_std_plcy_def_param1 = this.getValue(obj, ['ngips_ddos_std_plcy_def_param1', 'ads_ddos_std_plcy_def_param1'], 'ddos_std_plcy_def_param1')
    this.ddos_std_plcy_min_param1 = this.getValue(obj, ['ngips_ddos_std_plcy_min_param1', 'ads_ddos_std_plcy_min_param1'], 'ddos_std_plcy_min_param1')
    this.ddos_std_plcy_max_param1 = this.getValue(obj, ['ngips_ddos_std_plcy_max_param1', 'ads_ddos_std_plcy_max_param1'], 'ddos_std_plcy_max_param1')
    this.ddos_std_plcy_def_param2 = this.getValue(obj, ['ngips_ddos_std_plcy_def_param2', 'ads_ddos_std_plcy_def_param2'], 'ddos_std_plcy_def_param2')
    this.ddos_std_plcy_min_param2 = this.getValue(obj, ['ngips_ddos_std_plcy_min_param2', 'ads_ddos_std_plcy_min_param2'], 'ddos_std_plcy_min_param2')
    this.ddos_std_plcy_max_param2 = this.getValue(obj, ['ngips_ddos_std_plcy_max_param2', 'ads_ddos_std_plcy_max_param2'], 'ddos_std_plcy_max_param2')
    this.ddos_std_plcy_def_attk_mask_v4 = this.getValue(obj, ['ngips_ddos_std_plcy_def_attk_mask_v4', 'ads_ddos_std_plcy_def_attk_mask_v4'], 'ddos_std_plcy_def_attk_mask_v4')
    this.ddos_std_plcy_def_vtm_mask_v4 = this.getValue(obj, ['ngips_ddos_std_plcy_def_vtm_mask_v4', 'ads_ddos_std_plcy_def_vtm_mask_v4'], 'ddos_std_plcy_def_vtm_mask_v4')
    this.ddos_std_plcy_def_attk_mask_v6 = this.getValue(obj, ['ngips_ddos_std_plcy_def_attk_mask_v6', 'ads_ddos_std_plcy_def_attk_mask_v6'], 'ddos_std_plcy_def_attk_mask_v6')
    this.ddos_std_plcy_def_vtm_mask_v6 = this.getValue(obj, ['ngips_ddos_std_plcy_def_vtm_mask_v6', 'ads_ddos_std_plcy_def_vtm_mask_v6'], 'ddos_std_plcy_def_vtm_mask_v6')

    this.ddos_prtc = this.getValue(obj, ['', 'ads_ddos_prtc'], 'ddos_prtc')
    this.ddos_opt_learn_yn = this.getValue(obj, ['', 'ads_ddos_opt_learn_yn'], 'ddos_opt_learn_yn')
    this.ddos_opt_learn_cnt = this.getValue(obj, ['', 'ads_ddos_opt_learn_cnt'], 'ddos_opt_learn_cnt')
  }
  getValue (obj, arr, key) {
    this.keyList.push(key)
    this.orgKeyList.push(this.modelType === 'ips' ? arr[0] : arr[1])
    return _.cloneDeep(_.get(_.values(_.pick(obj, [...arr, key])), 0, void 0))
  }
  get () {
    const ret = {}
    _.forEach(this.keyList, key => {
      ret[key] = this[key]
    })
    return ret
  }
  fromApiParam () {
    const ret = {}
    _.forEach(this.keyList, (key, idx) => {
      const orgKey = this.orgKeyList[idx]
      ret[orgKey] = this[key]
    })
    return ret
  }
}
// 예외 호스트
class ExceptHostAddForm {
  constructor (obj, modelType = 'ips') {
    this.modelType = modelType
    this.ddos_excpt_host_desc = obj.ddos_excpt_host_desc
    this.ddos_list = _.cloneDeep(obj.ddos_list)
    this.prf_id = obj.prf_id
    this.ddos_excpt_list = _.cloneDeep(obj.ddos_excpt_list)
  }
  getApiParam () {
    if (this.modelType === 'ips') {
      return {
        ngips_prf_id: this.prf_id,
        ngips_ddos_excpt_host_desc: this.ddos_excpt_host_desc,
        ngips_ddos_list: this.ddos_list,
        ngips_ddos_excpt_list: _.map(this.ddos_excpt_list, o => {
          return {
            ngips_ddos_excpt_host_src_addr_obj_id: o.src_addr_obj_id,
            ngips_ddos_excpt_host_dst_addr_obj_id: o.dst_addr_obj_id
          }
        })
      }
    } else if (this.modelType === 'ads') {
      return {
        ads_prf_id: this.prf_id,
        ads_ddos_excpt_host_desc: this.ddos_excpt_host_desc,
        ads_ddos_id_list: this.ddos_list,
        ads_ddos_excpt_list: this.ddos_excpt_list
      }
    }
    return {}
  }
}

class ExceptHostGetForm {
  constructor (obj) {
    // ips
    if (_.has(obj, 'ngips_ddos_opt_excpthost')) {
      this.policy_exc_desc = obj.ngips_ddos_opt_excpthost
      this.items = _.map(obj.items, o => {
        return {
          src_addr_obj_id: o.ngips_ddos_excpt_host_src_addr_obj_id,
          src_ip_ver: o.ngips_ddos_excpt_host_src_ip_ver_type,
          src_name: o.ngips_ddos_excpt_host_src_obj_uname,
          src_type: o.ngips_ddos_excpt_host_src_obj_type,
          dst_addr_obj_id: o.ngips_ddos_excpt_host_dst_addr_obj_id,
          dst_ip_ver: o.ngips_ddos_excpt_host_dst_ip_ver_type,
          dst_name: o.ngips_ddos_excpt_host_dst_obj_uname,
          dst_type: o.ngips_ddos_excpt_host_dst_obj_type
        }
      })
    }
    // ads
    if (_.has(obj, 'ads_ddos_opt_excpthost')) {
      this.policy_exc_desc = obj.ads_ddos_opt_excpthost
      this.items = _.map(obj.items, o => {
        return {
          src_addr_obj_id: o.src_addr_obj_id,
          src_ip_ver: o.src_ip_ver_type,
          src_type: o.src_obj_type,
          src_name: o.src_obj_uname,
          dst_addr_obj_id: o.dst_addr_obj_id,
          dst_ip_ver: o.dst_ip_ver_type,
          dst_type: o.dst_obj_type,
          dst_name: o.dst_obj_uname
        }
      })
    }
  }
}
// 다른 프로파일 적용 Params
class OtherProfileApplyForm {
  constructor (obj, modelType) {
    if (modelType === 'ips') {
      this.ngips_profile_list = obj.profile_list
      this.ngips_ddos_items = _.mapKeys(obj.ddos_items, (val, key) => {
        return `ngips_${key}`
      })
    }
    if (modelType === 'ads') {
      this.ads_ips_prf_id_list = obj.profile_list
      this.ads_ddos_items = _.mapKeys(obj.ddos_items, (val, key) => {
        return `ads_${key}`
      })
    }
  }
}

class LearningData {
  constructor (obj) {
    this.src_ip = obj.ads_ddos_limit_src_ip
    this.dst_ip = obj.ads_ddos_limit_dst_ip
    this.detect_limit = obj.ads_ddos_limit_detect_limit
    this.block_limit = obj.ads_ddos_limit_block_limit
  }
}
class LearningAddForm {
  constructor (obj) {
    this.ads_ips_prf_id = obj.prf_id
    this.ads_ddos_id = obj.ddos_id
    this.ads_ddos_limit_list = _.map(obj.limit_list, limitItem => {
      return {
        ads_ddos_limit_ip_ver: 1,
        ads_ddos_limit_src_ip: limitItem.src_ip,
        ads_ddos_limit_dst_ip: limitItem.dst_ip,
        ads_ddos_limit_detect_limit: limitItem.detect_limit,
        ads_ddos_limit_block_limit: limitItem.block_limit
      }
    })
  }
}

export const state = () => ({
  ddosPolicyList: [],
  orgDdosPolicyList: []
})

export const mutations = {
  initStore (state) {
    state.ddosPolicyList = []
    state.orgDdosPolicyList = []
  },
  /**
   * 전달된 정책 ID를 찾아 스토어에 저장한다.
   */
  setDdosPolicyItem (state, policy) {
    const idx = state.ddosPolicyList.findIndex(({ddos_id: id}) => id === policy.ddos_id)

    if (idx > -1) {
      const copy = _.cloneDeep(state.ddosPolicyList)
      copy[idx] = policy

      state.ddosPolicyList = Object.freeze(copy)
    }
  },
  /**
   * 전달된 정책 ID를 찾아 스토어에 저장한다.
   */
  setDdosPolicyItems (state, rules) {
    const copy = _.cloneDeep(state.ddosPolicyList)
    _.forEach(rules, (policy) => {
      const idx = state.ddosPolicyList.findIndex(({ddos_id: id}) => id === policy.ddos_id)
      if (idx > -1) copy[idx] = policy
    })
    state.ddosPolicyList = Object.freeze(copy)
  },
  /**
   * 예외호스트를 저장한다.
   */
  setHostItems (state, rules) {
    const copy = _.cloneDeep(state.ddosPolicyList)
    rules = _.map(rules, o => new ServiceAttackDefense(o).get())
    _.forEach(rules, (policy) => {
      const idx = state.ddosPolicyList.findIndex(({ddos_id: id}) => id === policy.ddos_id)
      if (idx > -1) {
        copy[idx].ddos_opt_excpthost = policy.ddos_opt_excpthost
      }
    })
    state.ddosPolicyList = Object.freeze(copy)
  },
  /**
   * 서비스 공격 방어 목록을 스토어에 저장한다.
   */
  initDdosPolicyList (state, ddosList) {
    state.ddosPolicyList = Object.freeze(_.map(ddosList, o => new ServiceAttackDefense(o).get()))
    state.orgDdosPolicyList = _.cloneDeep(_.map(state.ddosPolicyList, o => new ServiceAttackDefense(o).get()))
  },
  /**
   * 서비스 공격 방어 목록을 스토어에 저장한다.
   */
  setDdosPolicyList (state, ddosList) {
    state.ddosPolicyList = Object.freeze(_.cloneDeep(ddosList))
  },
  /**
   * 원본 데이터를 복사한다.
   */
  copyDdosPolicyList (state) {
    state.orgDdosPolicyList = _.cloneDeep(state.ddosPolicyList)
  },
  /** 학습 설정을 수정한다. **/
  setLeaningCount (state, payload) {
    const copyDataList = _.cloneDeep(state.ddosPolicyList)
    const idx = _.findIndex(copyDataList, o => o.ddos_id === payload.ddos_id)
    if (idx > -1) {
      copyDataList[idx].ddos_opt_learn_cnt = _.size(payload.limit_list)
    }
    state.ddosPolicyList = Object.freeze(_.cloneDeep(copyDataList))
  }
}

export const actions = {
  /**
   * 서비스 공격 방어 정책 목록을 리턴한다.
   */
  async getDdosPolicyList ({rootState, commit}, {id, loading = true}) {
    const res = {
      code: 'ok'
    }

    try {
      const modelType = rootState.cm.objectSecProfile.ips.ipsIDProfileSettings.detectionPolicyProfile.modelType
      const url = (modelType === 'ips') ? `${smApiPrefix}/ddos/profiles/${id}/polices` : `${cmApiPrefix}/adsprf/ddos/profiles/${id}/polices`
      const {code, result} = await this.$axios.$get(url, {loading})

      if (code === 'ok') {
        commit('initDdosPolicyList', result)
      } else {
        res.code = code
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  },
  /**
   * 서비스 공격 방어 정책을 설정한다.
   */
  async setDdosPolicyDefense ({rootState, state, commit, dispatch}, {id, params, loading = true, successAlert = true}) {
    const res = {
      code: 'ok'
    }
    const modelType = rootState.cm.objectSecProfile.ips.ipsIDProfileSettings.detectionPolicyProfile.modelType
    // const
    params.items = _.map(params.items, o => {
      const profile = new ServiceAttackDefense(o, modelType)
      return profile.fromApiParam()
    })
    try {
      const url = (modelType === 'ips') ? `${smApiPrefix}/ddos/profiles/${id}/polices` : `${cmApiPrefix}/adsprf/ddos/profiles/${id}/polices`
      const {code, result} = await this.$axios.$put(url, params, {loading, successAlert})

      if (code === 'ok') {
        res.result = result

        if (result.msg) {
          res.reason = result.msg
        }
      } else {
        res.code = 'nok'
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  },
  /**
   * 서비스 공격 방어 정책에 적용된 예외 호스트 정보를 조회한다.
   */
  async getExceptHostDatas ({rootState, commit}, {id, policyId, loading = true, isNotAlert = true}) {
    const res = {
      code: 'ok'
    }

    try {
      const modelType = rootState.cm.objectSecProfile.ips.ipsIDProfileSettings.detectionPolicyProfile.modelType
      const url = (modelType === 'ips') ? `${smApiPrefix}/ddos/profiles/${id}/polices/${policyId}/exception-hosts` : `${cmApiPrefix}/adsprf/ddos/profiles/${id}/polices/${policyId}/exception-hosts`
      const {code, result} = await this.$axios.$get(url, {loading, isNotAlert})

      if (code === 'ok') {
        res.result = new ExceptHostGetForm(result)
      } else {
        res.code = code
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  },
  /**
   * 서비스 공격 방어 정책에 적용된 예외 호스트 정보를 수정한다.
   */
  async setExceptHostDatas ({rootState, commit, dispatch}, {params, loading = true, successAlert = true}) {
    const res = {
      code: 'ok'
    }

    try {
      const profileId = params.prf_id
      const modelType = rootState.cm.objectSecProfile.ips.ipsIDProfileSettings.detectionPolicyProfile.modelType
      const url = (modelType === 'ips') ? `${smApiPrefix}/ddos/profiles/${profileId}/polices/exception-hosts` : `${cmApiPrefix}/adsprf/ddos/profiles/${profileId}/polices/exception-hosts`
      params = new ExceptHostAddForm(params, modelType).getApiParam()
      const {code, result} = await this.$axios.$put(url, params, {loading, successAlert})

      if (code === 'ok') {
        res.result = result
        if (result.length > 0) {
          commit('setHostItems', result)
        }
      } else {
        res.code = code
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  },
  /**
   * 현재 프로파일의 서비스 공격 방어 설정을 기본 설정으로 복구한다.
   */
  async resetDdosProfile ({rootState, state, dispatch, commit}, {id, loading = true, menuKey = ''}) {
    const res = {
      code: 'ok'
    }

    try {
      let headers = null

      if (menuKey) {
        headers = {
          'X-Gui-Menu': menuKey
        }
      }

      const modelType = rootState.cm.objectSecProfile.ips.ipsIDProfileSettings.detectionPolicyProfile.modelType
      const url = (modelType === 'ips') ? `${smApiPrefix}/ddos/profiles/${id}/polices/default` : `${cmApiPrefix}/adsprf/ddos/profiles/${id}/polices/default`
      const {code} = await this.$axios.$put(url, null, {loading, headers, successAlert: true})

      res.code = code
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  },
  /**
   * 전달된 URL에 해당하는 파일 다운로드를 요청한다.
   */
  async getExcelDownload ({rootState, commit}, {id}) {
    const modelType = rootState.cm.objectSecProfile.ips.ipsIDProfileSettings.detectionPolicyProfile.modelType
    const url = (modelType === 'ips') ? `${smApiPrefix}/ddos/profiles/${id}/polices/file` : `${cmApiPrefix}/adsprf/ddos/profiles/${id}/polices/file`
    const result = await this.$axios.$file(url, {responseType: 'blob'})
    return result
  },
  /**
   * 서비스 공격 방어 정책을 다른 프로파일에 적용한다.
   */
  async setOtherProfiles ({rootState, state, commit, dispatch}, {ddosId, params, loading = true, successAlert = true}) {
    const res = {
      code: 'ok'
    }

    try {
      const modelType = rootState.cm.objectSecProfile.ips.ipsIDProfileSettings.detectionPolicyProfile.modelType
      const url = (modelType === 'ips') ? `${smApiPrefix}/ddos/apply-profiles/polices/${ddosId}` : `${cmApiPrefix}/adsprf/ddos/apply-profiles/polices/${ddosId}`
      params = new OtherProfileApplyForm(params, modelType)
      const {code, result} = await this.$axios.$post(url, params, {loading, successAlert, alertMsg: i18n.t('msg.updateApply')})
      if (code === 'ok') {
        if (result.msg) {
          res.reason = result.msg
        }
      } else {
        res.code = 'nok'
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  },
  // 서비스 공격 방어의 임계치를 조회
  async getDdosHostLimit ({state, dispatch, commit}, {id, policyId, loading = true}) {
    const res = { code: 'ok' }
    try {
      const {code, result, reason} = await this.$axios.$get(`${cmApiPrefix}/adsprf/ddos/profiles/${id}/polices/${policyId}/limit`, {loading})

      if (code === 'ok') {
        res.result = _.map(result, o => new LearningData(o))
      } else {
        res.code = code
        res.reason = reason
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  },
  // 서비스 공격 방어의 임계치 설정 (추가)
  async setDdosHostLimit ({commit}, {params, loading = true, successAlert = true}) {
    const res = { code: 'ok' }
    try {
      const prfId = params.items[0].prf_id
      const ddosId = params.items[0].ddos_id
      const paramData = new LearningAddForm(params.items[0])
      const {code, result} = await this.$axios.$post(`${cmApiPrefix}/adsprf/ddos/profiles/${prfId}/polices/${ddosId}/limit`, paramData, {loading, successAlert})

      if (code === 'ok') {
        commit('setLeaningCount', params.items[0])
        // dispatch('common/common/setIsChanged', true, {root: true})
      } else {
        res.code = code
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  }
}
